// RequireAuth.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from './UserContext';

const RequireAuth = ({ children, adminOnly, allowedRoles }) => {
  const { user, userData, loadingUser } = useUser();

  if (loadingUser || user === undefined) {
    return <div>Перевіряємо доступ...</div>;
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  const roles = allowedRoles || (adminOnly ? ['admin'] : null);

  if (roles && !roles.includes(userData?.role)) {
    return <Navigate to="/" />;
  }

  return children;
};

export default RequireAuth;
